import { Button, ButtonRow } from '@ksyos/design-system';
import type { EpisodeCategory } from '../../../../common/enums/episodeCategory';
import type { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { HeroTitle } from '../../elements/common';

export interface IEmptyEpisodeProps {
    episodeCategory: EpisodeCategory;
    onClick: (serviceType: ServiceType) => Promise<void> | void;
    serviceTypes: ServiceType[];
}

export function EmptyEpisode(props: IEmptyEpisodeProps) {
    return (
        <div className="empty-episode-container">
            <div className="__text-body">
                <HeroTitle
                    text={translateKey(
                        'episodes.emptyEpisode',
                        translateKey(`episodeCategoryEnum.${props.episodeCategory}`)
                    )}
                />
                <ButtonRow
                    isStackedBelowSmall={true}
                    justify="center"
                >
                    {props.serviceTypes.map((serviceType) => (
                        <Button
                            className={`automation-processFlowType-${serviceType}`}
                            color="secondary"
                            key={serviceType}
                            onClick={async () => await props.onClick(serviceType)}
                            variant="outline"
                        >
                            {translateKey(`home.type_${serviceType}`)}
                        </Button>
                    ))}
                </ButtonRow>
            </div>
        </div>
    );
}
